import { InputContainer } from '../../Input'
import { useSelectContext } from '../Select.hooks'

function SelectControlContainer({ ref, ...props }) {
  const { error } = useSelectContext()

  return <InputContainer {...props} hasError={!!error} ref={ref} />
}

export default SelectControlContainer
